import {
  BrandsStep,
  PresentationsTabsPath,
  ReportTypeStep,
  SelectionsStep
} from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/types';

export const dataStructures = {
  category: {
    label: 'Categories & Subcategories',
    description: 'Select categories and subcategories below for this presentation.',
    width: '256px'
  },
  segment: {
    label: 'Segment',
    description: 'Select one segment below that meets the minimum brand requirements for this presentation.'
  },
  businessunit: {
    label: 'Business Unit',
    description: 'Select one business unit below that meets the minimum brand requirements for this presentation.'
  }
};

export const brandsCategories = {
  default: {
    label: 'Top 10 Brands',
    description: 'Highlight insights from the top 10 brands from your data structure selection.',
    width: '284px'
  },
  custom: {
    label: 'Custom Brand Groupings',
    description: 'Highlight insights from custom groupings from your data structure selection.',
    comingSoon: true
  }
};

export const initialType: ReportTypeStep = {
  reportType: { id: '', name: '' }
};
export const initialSelections: SelectionsStep = {
  currency: '',
  retailerIds: [],
  entityType: {
    id: 'category',
    name: dataStructures['category'].label
  },
  entityId: { id: '', name: '' },
  categoryIds: [],
  subcategoryIds: []
};
export const initialBrands: BrandsStep = {
  brandGroupings: { id: 'default', name: brandsCategories['default'].label }
};

export const validationSteps = {
  [PresentationsTabsPath.type]: { error: 'Please select a presentation type' },
  [PresentationsTabsPath.selections]: { error: 'Please select all required fields' },
  [PresentationsTabsPath.brands]: { error: 'Please select a brand grouping' },
  [PresentationsTabsPath.confirmations]: { error: '' }
};
